import type { CardDesignTokens } from '@primeuix/themes/types/card'

export default {
  body: {
    gap: '0.75rem',
    padding: '1.25rem',
  },
  root: {
    color: '{content.color}',
    shadow: '0 1px .25rem rgba(0,0,0,.075)',
    background: '{content.background}',
    borderRadius: '{border.radius.xl}',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: '500',
  },
  caption: {
    gap: '0.5rem',
  },
  subtitle: {
    color: '{text.muted.color}',
  },
} satisfies CardDesignTokens
